// 配置全局常量

window.base_image_url = 'https://arzu.mldqanal.cn/uploads/images/'
